// extracted by mini-css-extract-plugin
export default {"sec":"IntroPg_sec__dOQ0F","ul":"IntroPg_ul__SznBG","name":"IntroPg_name__EUAzO"};